export const tourPagesDb = {
    add: (pageName) => {
        let touredPages = localdb.get("tour_pages");
        if (touredPages) {
            touredPages = JSON.parse(touredPages);
        } else {
            touredPages = [];
        }
        touredPages.push(pageName);
        localdb.put("tour_pages", JSON.stringify(touredPages));
    },

    get: (pageName) => {
        let touredPages = localdb.get("tour_pages");
        if (touredPages) {
            touredPages = JSON.parse(touredPages);
            return touredPages.find((page) => page === pageName);
        }
    },
    remove: (pageName) => {
        let touredPages = localdb.get("tour_pages");
        if (touredPages) {
            touredPages = JSON.parse(touredPages);
            const index = touredPages.indexOf(pageName);
            if (index > -1) {
                touredPages.splice(index, 1);
                localdb.put("tour_pages", JSON.stringify(touredPages));
            }
        }
    },

    removeAll: () => {
        localdb.remove("tour_pages");
    }
}


export const localdb = {
    put: (k, v) => {
        localStorage.setItem(buildKey(k), v)
    },
    get: (k) => {
        return localStorage.getItem(buildKey(k));
    },
    remove: (k) => {
        localStorage.removeItem(buildKey(k));
    },
    getKey: (k) => {
        return buildKey(k);
    }
}

const buildKey = (key) => {
    let prefix = "TF_";
    if (process.env.NODE_ENV === "development") {
        prefix += "DEV_"
    }
    return prefix + key;
}